// Session-level offline state, readable and writable from non-React code
// (UserContext callbacks, module timers, the API middleware) and subscribed
// to by ProtectedRoute / the offline components. Stays at its initial values
// for orgs without offline mode, so every consumer is a no-op there.

import { create } from 'zustand';

export const useOfflineSessionStore = create((set) => ({
  // Cold boot: 'idle' (normal online boot), 'hydrated' (booted from the
  // offline snapshot), 'blocked' (offline with no usable snapshot — the
  // reconnect wall renders instead of the spinner).
  bootState: 'idle',
  bootReason: null, // 'no-snapshot' | 'token-expired' | 'snapshot-mismatch' | 'solutions-unavailable' | 'timeout'

  // Inactivity / trust-window lock.
  locked: false,
  lockReason: null, // 'inactivity' | 'trust-window-expired'
  lockedAt: null,

  // Pending logout confirmation: { count, resolve } | null
  logoutPrompt: null,

  // Last "not available offline" notification: { message, at } | null
  unavailableNotice: null,

  setBootState: (bootState, bootReason = null) => set({ bootState, bootReason }),
  lock: (lockReason) => set({ locked: true, lockReason, lockedAt: Date.now() }),
  unlock: () => set({ locked: false, lockReason: null, lockedAt: null }),
  setLockReason: (lockReason) => set({ lockReason }),
  setLogoutPrompt: (logoutPrompt) => set({ logoutPrompt }),
  setUnavailableNotice: (unavailableNotice) => set({ unavailableNotice }),
}));

export function getOfflineSessionState() {
  return useOfflineSessionStore.getState();
}
